import { Row, Col, DatePicker, Space, Form } from "antd";
import { MonedaSelect } from "../reusable/MonedaSelect";
import { PedidoVentaFormDetalle } from "./PedidoVentaFormDetalle";
import { VendedorSelect } from "../reusable/VendedorSelect";
import { DateFormats, MonedaConstants } from "../../../types/typesConstants";
import { FormItemHiddenUi } from "../../ui/FormItemHiddenUi";
import { Card, CloseBtn, SaveBtn } from "../../ui";
import { ClienteRow } from "./ClienteRow";
import { EstadoPedidoVentaSelect } from "../reusable";
import { useSelector } from "react-redux";
import { PedidoVentaEstadosSteps } from "./PedidoVentaEstadosSteps";

export const PedidoVentaForm = ({ handleCloseForm }) => {
  const form = Form.useFormInstance();
  const { activePedidoVenta } = useSelector((state) => state.pedidoventa);
  const handleChangeMoneda = (e, field) => {
    const monedaprefijosunat = field?.prefijosunat;
    if (monedaprefijosunat === MonedaConstants.PEN) {
      form.setFieldsValue({ tipocambio: 1 });
    }
    form.setFieldsValue({
      moneda_prefijo: field?.prefijo,
      moneda_prefijosunat: field?.prefijosunat,
    });
  };
  return (
    <>
      <Card
        title="Pedido de Venta"
        size="small"
        extra={
          <Space wrap>
            <CloseBtn key="cerrar" onClick={handleCloseForm} />
            <SaveBtn key="guardar" htmlType="submit" />
          </Space>
        }
      >
        <FormItemHiddenUi name="id" />
        <FormItemHiddenUi name="montosubtotal" />
        <FormItemHiddenUi name="montoigvtotal" />
        <FormItemHiddenUi name="montototal" />
        <FormItemHiddenUi name="montototalgravadas" />
        <FormItemHiddenUi name="montototalexoneradas" />
        <FormItemHiddenUi name="montototalinafectas" />
        <FormItemHiddenUi name="moneda_prefijo" />
        <FormItemHiddenUi name="moneda_prefijosunat" />
        <FormItemHiddenUi name="cliente" />
        <FormItemHiddenUi name="estadospedidoventa" />
        <Row gutter={{ xs: 8, sm: 12, md: 16, lg: 16 }}>
          <Col span={24}>
            <PedidoVentaEstadosSteps />
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 12, md: 16, lg: 16 }} className="mt-2">
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={20}>
            <ClienteRow />
            <Row gutter={{ xs: 8, sm: 12, md: 16, lg: 16 }}>
              <Col xs={24} sm={24} md={24} lg={12} xl={10} xxl={10}>
                <Form.Item
                  name="vendedor"
                  rules={[
                    { required: true, message: "El vendedor es obligatorio" },
                  ]}
                >
                  <VendedorSelect
                    placeholder="Seleccione vendedor"
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={6} xxl={4}>
                <Form.Item
                  name="moneda"
                  rules={[
                    { required: true, message: "La moneda es obligatoria" },
                  ]}
                >
                  <MonedaSelect
                    placeholder="Seleccione moneda"
                    onChange={handleChangeMoneda}
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 12, md: 16, lg: 24 }}>
              <Col xs={24} sm={24} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item name="fechapedido" label="Fecha pedido">
                  <DatePicker format={DateFormats.frontend} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item name="fechaentrega" label="Fecha entrega">
                  <DatePicker format={DateFormats.frontend} />
                </Form.Item>
              </Col>
              {activePedidoVenta && (
                <Col xs={24} sm={24} md={8} lg={8} xl={6} xxl={4}>
                  <Form.Item name="estado" label="Estado">
                    <EstadoPedidoVentaSelect placeholder="[-Seleccione-]" />
                  </Form.Item>
                </Col>
              )}
            </Row>
            <PedidoVentaFormDetalle />
          </Col>
        </Row>
      </Card>
    </>
  );
};
